module.exports = __webpack_public_path__ + "img/retired-2016-agri.a31f08af.jpg";